/**
 * A fraction and a line, not a row of numbered circles — see the design
 * notes in styles.css's "Apply flow" section. Only the four authenticated
 * steps count; pre-qualification is exploratory and isn't part of the tally.
 */
const STEPS = ['Account', 'Your details', 'Application fee', 'Submit'] as const;

export function ApplyProgress({ step }: { step: 1 | 2 | 3 | 4 }) {
  const current = STEPS[step - 1];
  return (
    <div className="apply-progress">
      <div className="apply-progress__label">
        Step {step} of {STEPS.length} — {current}
      </div>
      <div className="apply-progress__track">
        <div
          className="apply-progress__fill"
          style={{ width: `${String((step / STEPS.length) * 100)}%` }}
        />
      </div>
    </div>
  );
}
